module.exports = __webpack_public_path__ + "static/media/OlderWoman.2a624eab.png";